import type { ReactElement } from 'react';
import { TaxreturnBudgets } from './TaxreturnBudgets';
import { TaxreturnDimensions } from './TaxreturnDimensions';
import { TaxreturnIntegrations } from './TaxreturnIntegrations';
import { TaxreturnIntegrationsHistory } from './TaxreturnIntegrationsHistory';
import { TaxreturnIntegrationsPersonlist } from './TaxreturnIntegrationsPersonlist';
import { TaxreturnLogsEmaillogs } from './TaxreturnLogsEmaillogs';
import { TaxreturnLogsUserlogs } from './TaxreturnLogsUserlogs';
import { TaxreturnManagementPacks } from './TaxreturnManagementPacks';
import { TaxreturnManagementPeriods } from './TaxreturnManagementPeriods';
import { TaxreturnPeriodicTrialbalance } from './TaxreturnPeriodicTrialbalance';

/** Ported screens of this slice, keyed by their Angular URL (see src/app/routeManifest.ts). */
export const screens: Record<string, ReactElement> = {
  '/home/taxreturns/reports-managementperiods': <TaxreturnManagementPeriods />,
  '/home/taxreturns/reports-periodictrialbalance': <TaxreturnPeriodicTrialbalance />,
  '/home/taxreturns/reports-budgets': <TaxreturnBudgets />,
  '/home/taxreturns/reports-dimensions': <TaxreturnDimensions />,
  '/home/taxreturns/reports-managementpacks': <TaxreturnManagementPacks />,
  '/home/taxreturns/integrations-companyofficers': <TaxreturnIntegrations />,
  '/home/taxreturns/integrations-persons': <TaxreturnIntegrationsPersonlist />,
  '/home/taxreturns/integrations-history': <TaxreturnIntegrationsHistory />,
  '/home/taxreturns/emaillogs': <TaxreturnLogsEmaillogs />,
  '/home/taxreturns/userlogs': <TaxreturnLogsUserlogs />,
};
